import type { ClientTheme } from "@/app/lib/themes"

interface SegmentedControlProps {
  value: string
  onChange: (next: string) => void
  options: { label: string; value: string }[]
  theme: ClientTheme
}

/**
 * Small tri-state (or n-state) toggle for filters like Has Well: All/Yes/No.
 * Every state is visible at a glance and one click away — nicer than a
 * dropdown for 2–3 fixed options.
 */
export function SegmentedControl({ value, onChange, options, theme }: SegmentedControlProps) {
  return (
    <div
      className="inline-flex rounded-lg"
      style={{
        padding: "2px",
        gap: "2px",
        backgroundColor: theme.bgSurface2,
        border: `1px solid ${theme.borderColor}`,
      }}
      role="group"
    >
      {options.map((opt) => {
        const active = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={active}
            className="rounded-md"
            style={{
              fontFamily: "var(--font-ui)",
              fontSize: "12px",
              fontWeight: active ? 600 : 500,
              padding: "5px 10px",
              color: active ? theme.textPrimary : theme.textMuted,
              backgroundColor: active ? theme.bgSurface : "transparent",
              border: `1px solid ${active ? theme.borderColor : "transparent"}`,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background-color 120ms ease, color 120ms ease",
            }}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
